import { Link } from 'react-router-dom';
import { Mail, Phone, MapPin, Linkedin } from 'lucide-react';

export function Footer() {
  return (
    <footer className="bg-gradient-to-b from-muted/50 to-muted border-t border-border/50">
      <div className="container mx-auto px-4 lg:px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* Brand Section */}
          <div>
            <Link to="/" className="inline-block mb-4">
              <span className="text-2xl md:text-3xl font-bold text-slate-900 tracking-tight">
                BrazzaBoost
              </span>
            </Link>
            <p className="text-muted-foreground text-sm leading-relaxed mt-2">
              LA plateforme de référence pour la jeunesse de Brazzaville. Trouvez votre opportunité aujourd&apos;hui - Tozali awa na bolingo!
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="font-semibold text-foreground mb-4">Liens Rapides</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/opportunities" className="text-muted-foreground hover:text-primary text-sm transition-colors">
                  Toutes les opportunités
                </Link>
              </li>
              <li>
                <Link to="/blog" className="text-muted-foreground hover:text-primary text-sm transition-colors">
                  Blog & Conseils
                </Link>
              </li>
              <li>
                <Link to="/feedback" className="text-muted-foreground hover:text-primary text-sm transition-colors">
                  Donner votre avis
                </Link>
              </li>
              <li>
                <Link to="/cv-builder" className="text-muted-foreground hover:text-primary text-sm transition-colors">
                  Créer mon CV
                </Link>
              </li>
            </ul>
          </div>

          {/* Categories */}
          <div>
            <h3 className="font-semibold text-foreground mb-4">Catégories</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/opportunities?type=emploi" className="text-muted-foreground hover:text-primary text-sm transition-colors">
                  Emplois
                </Link>
              </li>
              <li>
                <Link to="/opportunities?type=stage" className="text-muted-foreground hover:text-primary text-sm transition-colors">
                  Stages
                </Link>
              </li>
              <li>
                <Link to="/opportunities?type=bourse" className="text-muted-foreground hover:text-primary text-sm transition-colors">
                  Bourses
                </Link>
              </li>
              <li>
                <Link to="/opportunities?type=formation" className="text-muted-foreground hover:text-primary text-sm transition-colors">
                  Formations
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h3 className="font-semibold text-foreground mb-4">Contact</h3>
            <ul className="space-y-3">
              <li className="flex items-center gap-2">
                <Mail className="h-4 w-4 text-honor-orange" />
                <span className="text-muted-foreground text-sm">pamani@aisbrazza.org</span>
              </li>
              <li className="flex items-center gap-2">
                <Phone className="h-4 w-4 text-primary" />
                <span className="text-muted-foreground text-sm">+242 068546715</span>
              </li>
              <li className="flex items-center gap-2">
                <MapPin className="h-4 w-4 text-primary" />
                <span className="text-muted-foreground text-sm">Brazzaville, Congo</span>
              </li>
            </ul>
            
            {/* Social Media */}
            <div className="flex gap-3 mt-4">
              <a href="https://www.linkedin.com/company/brazzaboost/about/?viewAsMember" target="_blank" rel="noopener noreferrer" className="w-10 h-10 flex items-center justify-center rounded-full bg-card hover:bg-primary hover:text-white transition-all border border-border" aria-label="LinkedIn">
                <Linkedin className="h-5 w-5" />
              </a>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-border mt-8 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-muted-foreground text-sm">
              © 2025 BrazzaBoost. Tous droits réservés.
            </p>
            <div className="flex gap-4">
              <Link to="/privacy" className="text-muted-foreground hover:text-primary text-sm transition-colors">
                Politique de confidentialité
              </Link>
              <Link to="/terms" className="text-muted-foreground hover:text-primary text-sm transition-colors">
                Conditions d'utilisation
              </Link>
              <Link to="/feedback" className="text-muted-foreground hover:text-primary text-sm transition-colors">
                Donner votre avis
              </Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}

export default Footer;